var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "col-12 py-2 results-heading d-flex justify-content-between",
    },
    [
      _c("div", { staticClass: "count-wrap" }, [
        _c("h4", [_vm._v("Search Results")]),
        _vm._v(" "),
        _c("div", { staticClass: "counts" }, [
          _vm._v(
            "\n        Showing " +
              _vm._s(_vm.min_count) +
              " - " +
              _vm._s(_vm.count) +
              " of " +
              _vm._s(_vm.total_count) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "download-buttons-wrap" }, [
        _c("span", [_vm._v("Export as:")]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary mx-1",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.generateCSV()
              },
            },
          },
          [_vm._v("CSV")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-dark",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.generatePDF()
              },
            },
          },
          [_vm._v("PDF")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }